import { createContext } from "react";
import type { AuthContextType } from "@repo/types/contexts";

const AuthContext = createContext<AuthContextType | null>(null);

export { AuthContext };
